import React from 'react';
import { Link } from 'react-router-dom';
import { SuitDiamondMark } from './BrandMarks';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner container">
        <div className="footer-brand">
          <div className="footer-lockup">
            <SuitDiamondMark size={22} />
            <span className="footer-name">The Pantry Life</span>
          </div>
          <span className="footer-copy">© {new Date().getFullYear()} The Pantry Life. All rights reserved.</span>
        </div>
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/support" className="footer-link">Support</Link>
        </nav>
      </div>
    </footer>
  );
}
